/* Common sorting on primitive elements */

export default new class SortAssistant {
  public sortChronologically(array: number[]): number[] {
    return array.sort((a, b) => (a > b ? 1 : -1))
  }
}()
